import React from 'react';
import { IconBase, IconProps } from '../IconBase';

export const CopyIcon = ({ size, color, title, onClick, decorative, ...restItems }: IconProps) => (
	<IconBase
		viewBox="0 0 24 24"
		size={size}
		color={color}
		title={title}
		onClick={onClick}
		decorative={decorative}
		{...restItems}
	>
		<path
			d="M8.5 7V15C8.5 15.2812 8.71875 15.5 9 15.5H15V14C15 13.4688 15.4375 13 16 13H17.5V7C17.5 6.75 17.25 6.5 17 6.5H9C8.71875 6.5 8.5 6.75 8.5 7ZM7 7C7 5.90625 7.875 5 9 5H17C18.0938 5 19 5.90625 19 7V13.1875C19 13.7188 18.7812 14.2188 18.4062 14.5938L16.5625 16.4375C16.1875 16.8125 15.6875 17 15.1562 17H9C7.875 17 7 16.125 7 15V7ZM14 19.25C14 19.6875 13.6562 20 13.25 20H8.25C5.875 20 4 18.125 4 15.75V8.75C4 8.34375 4.3125 8 4.75 8C5.15625 8 5.5 8.34375 5.5 8.75V15.75C5.5 17.2812 6.71875 18.5 8.25 18.5H13.25C13.6562 18.5 14 18.8438 14 19.25Z"
			fill="#31302F"
		/>
	</IconBase>
);
